module.exports = __webpack_public_path__ + "static/media/qr-bilibili.e2dc9d96.jpg";